<template>
  <div>
    <el-dialog
      :visible.sync="showDialog"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="study-line-dialog">
      <img src="../../common/img/study_line_icon.png" alt="" class="line-icon">
      <div class="head-container" slot="title"></div>
      <div class="line-title">{{$lang.call_notification}}</div>
      <div class="middle-container">
        {{$lang.study_call_tips.replace('%template%', liveInfo.teacherName)}}
      </div>
      <div class="bottom-btns">
        <el-button @click="onCancel" :loading="isBtnLoading">{{$lang.cancel_reservation}}</el-button>
        <el-button type="primary" @click="toStudyLive" class="enter-btn" :loading="isBtnLoading">{{$lang.enter_live}} ({{seconds}}s)</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import createWebSocket from '@/utils/websocket'
import {auditButtonManageByType} from '../../api/index/index'
import {cancelStudyRoomSubscribe, entryStudyRoom} from '../../api/learn/expert'
export default {
  async created () {
    await this.getStudyOpenStatus()
    if (this.userId && this.isStudyOpen) {
      this.initMyWebsocket()
    }
  },
  beforeDestroy () {
    // 组件销毁时关闭WebSocket
    this.myWebsocket.close()
  },
  computed: {
    userId () {
      return this.$store.state.Auth.userId
    }
  },
  watch: {
    showDialog () {
      if (this.showDialog) {
        // 开启倒计时
        this.startCountDownTimer()
      } else {
        clearInterval(this.countdownTimer)
        if (this.$route.meta.refreshExpert) {
          location.reload()
        }
      }
    }
  },
  data () {
    return {
      isStudyOpen: false,
      heartbeatTimer: null,
      countdownTimer: null,
      seconds: 15,
      isBtnLoading: false,
      myWebsocket: null,
      liveInfo: {},
      showDialog: false
    }
  },
  methods: {
    async getStudyOpenStatus () {
      try {
        let params = {
          type: 6
        }
        const {data} = await auditButtonManageByType(params)
        if (data.resultCode === 0) {
          let {status} = data.resultData
          this.isStudyOpen = Boolean(status === 0)
        }
      } catch (error) {
      }
    },
    initMyWebsocket () {
      this.myWebsocket = createWebSocket(this.$config.ws_url + this.userId + '/1', {
        maxReconnectCount: 30,
        reconnectInterval: 3000,
        heartbeatInterval: 15 * 1000,
        heartbeatMsg: JSON.stringify({
          type: 3
        })
      })
      // 监听WebSocket事件
      this.myWebsocket.on('open', () => {
        // console.log('ws已连接')
      })
      this.myWebsocket.on('message', (data) => {
        // console.log('接收到ws消息', data)
        if (data.type === 10) {
          this.showDialog = true
          this.liveInfo = data
        }
        // this.messages.push(data)
      })
      this.myWebsocket.on('close', (event) => {
        // console.log(`ws已关闭 (${event.code})`)
      })
      this.myWebsocket.on('error', () => {
        // console.error('ws错误:', error)
      })
    },
    // 开启15s倒计时
    startCountDownTimer () {
      this.seconds = 15
      this.countdownTimer = setInterval(() => {
        if (this.seconds === 0) {
          clearInterval(this.countdownTimer)
          this.onCancel()
        } else {
          this.seconds -= 1
        }
      }, 1000)
    },
    // 进入答疑室
    toStudyLive () {
      this.myWebsocket.send(JSON.stringify({
        type: 20, // 确定进入直播
        studyRoomId: this.liveInfo.studyRoomId
      }))
      let params = {
        studyRoomId: this.liveInfo.studyRoomId
      }
      this.isBtnLoading = true
      entryStudyRoom(params).then((res) => {
        let routeData = this.$router.resolve({
          name: 'ToRoom',
          query: {
            id: this.liveInfo.studyRoomId,
            url: this.liveInfo.liveUrl,
            tempLogId: this.liveInfo.tempLogId
          }
        })
        window.open(routeData.href, '_blank')
      }).finally(() => {
        this.isBtnLoading = false
        this.showDialog = false
      })
    },
    // 取消排队
    onCancel () {
      this.isBtnLoading = true
      let params = {
        studyRoomId: this.liveInfo.studyRoomId
      }
      cancelStudyRoomSubscribe(params).then(res => {
        if (res.data.resultCode === 0) {
          this.myWebsocket.send(JSON.stringify({
            type: 21, // 取消进入教室
            studyRoomId: this.liveInfo.studyRoomId
          }))
        }
      }).finally(() => {
        this.showDialog = false
        this.isBtnLoading = false
      })
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.study-line-dialog{
  .el-dialog{
    width: 403px!important;
    border-radius: 34px!important;
    .el-dialog__header{
      padding: 0;
      .head-container{
        width: 100%;
        background-image: url('../../common/img/study_line_bg.png');
        background-size: 100% 100%;
        padding: 0;
        height: 81px;
      }
    }
    .line-icon{
      position: absolute;
      width: 120px;
      height: 120px;
      top: -60px;
      left: 50%;
      transform: translateX(-50%);
    }
    .el-dialog__body{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 30px 30px;
      .line-title{
        color: #303133;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      }
      .middle-container{
        font-size: 16px;
        color: #333;
        text-align: center;
        margin-top: 14px;
      }
      .bottom-btns{
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        margin-top: 40px;
        .el-button{
          border-radius: 12px;
          flex: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/StudyLineTips.vue